import { render } from "./EmailRegistrationModal.vue?vue&type=template&id=74e88a36"
import script from "./EmailRegistrationModal.vue?vue&type=script&lang=js"
export * from "./EmailRegistrationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__